module.exports = {"name":"theplatform","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.1","built":"2018-02-14","repo":"https://bitbucket.org/npaw/theplatform-adapter-js","libVersion":"6.1.12","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getTitle","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getBitrate","getTitle","getResource","getPosition"],"filename":"ads.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0